<template>
  <div class="users-out">
    <CDNTabs :tabs="tabs" />
    <div class='users-manage'>
      <div class="menu-title">
        <div class="menu-right">
         <div class="filter-container" @click="filterClick">
          <CDNButton
           :BtnText="$t('common.filter')"
           :hasBg="isFilter"
           :imgPath="require('@/assets/images/products/icon_filter.png')"
            />
            <CDNButton
              :hasBg="isFilter"
              :imgPath="require('@/assets/images/products/icon_down.png')"
              innerstyle="margin-left: 5px;"
            />
        </div>
          <CDNButton
           :BtnText="$t('common.refresh')"
           :imgPath="require('@/assets/images/products/icon_refresh.png')"
           innerstyle="margin-left: 24px;"
           @btnclick="refresh"
            />

        </div>
      </div>
      <div v-show="isFilter" class="input-container">
        <loginInput
         :label="$t('product.ProductName')"
         :appendIcon="require('@/assets/images/products/prod_icon_user.png')"
         inputStyle="width: 288px;"
         realInputStyle="width: 288px;"
         @changeInput="(e) => searchName = e"
         :inputValue="searchName"
          />
      <CDNDatePicker
        ref="createdate"
        :label="$t('product.createDate')"
        innerStyle="width: 288px; margin-left: 24px;"
        type="daterange"
        @changeDate="date => createDate = date"
       />
      </div>

      <div class="search-btn-content" v-show="isFilter">
        <CDNButton
         :hasBg="true"
          :imgPath="require('@/assets/images/products/prod_icon_search.png')"
          innerstyle="padding: 6px 20px;"
          :BtnText="$t('common.search')"
          @btnclick="searchClick"
           />
           <CDNButton
          :imgPath="require('@/assets/images/products/prod_icon_reset.png')"
          innerstyle="margin-left: 20px;padding: 6px 20px;"
          :BtnText="$t('common.reset')"
          @btnclick="resetClick"
           />
      </div>

      <!-- 列表 -->
      <el-table
       :data="tableData"
       height="500"
        style="width: 100%"
        >
        <el-table-column
          align="center"
          prop="name"
          :label="$t('product.ProductName')"
        >
        <template slot-scope="scope">
           <div style="cursor: pointer;" @click="$router.push({path:'/allDomain', query: { pid: scope.row.id}})">
             {{ scope.row['name'] }}
           </div>
        </template>
        </el-table-column>
        <el-table-column
          align="center"
          prop="hosts_limit"
          :label="$t('product.addedDomain')"
        >
        <template slot-scope="scope">
           {{`${scope.row['merchat_sub_host_count']}/${scope.row['hosts_limit']}`}}
        </template>
        </el-table-column>
        <el-table-column
          align="center"
          prop="attribute_asset"
          :label="$t('product.setMeal')"
        >
        <template slot-scope="scope">
             <div>
              {{scope.row['attribute_asset'] && scope.row['attribute_asset'].name}}
             </div>
        </template>
        </el-table-column>
        <el-table-column
          align="center"
          prop="created_at"
          :label="$t('product.createDate')"
        >
        </el-table-column>
        <el-table-column
          align="center"
          :label="$t('product.handle')"
        >
        <template slot-scope="scope">
          <div>
            
              <el-tooltip
                class="item"
                effect="dark"
                :content="$t('product.cache')"
                placement="top-start"
              >
                <el-button
                  size="mini"
                  type="success"
                  @click="$router.push({name: 'product_settings', params: { pid: scope.row.id, category: 'cache'}})"
                  icon="el-icon-folder-add"
                  circle
                ></el-button>
              </el-tooltip>

              <el-tooltip
                class="item"
                effect="dark"
                :content="$t('product.strategy')"
                placement="top-start"
              >
                <el-button
                  size="mini"
                  type="warning"
                  @click="$router.push({name: 'product_settings', params: { pid:  scope.row.id, category: 'strategy'}})"
                  icon="el-icon-s-opportunity"
                  circle
                ></el-button>
              </el-tooltip>
              <el-tooltip
                class="item"
                effect="dark"
                :content="$t('product.Statistics')"
                placement="top-start"
              >
                <el-button
                  size="mini"
                  type="primary"
                  @click="$router.push({name: 'product_static', params: { pid:  scope.row.id}})"
                  icon="el-icon-s-data"
                  circle
                ></el-button>
              </el-tooltip>
          </div>
           <!-- <div class="handle-first">
                  <div @click="$router.push({name: 'product_settings', params: { pid: scope.row.id, category: 'cache'}})">{{$t('product.cache')}}</div>
                  <div @click="$router.push({name: 'product_settings', params: { pid:  scope.row.id, category: 'strategy'}})">{{$t('product.strategy')}}</div>
                  <div @click="$router.push({name: 'product_static', params: { pid:  scope.row.id}})">{{ $t('product.Statistics')}}</div>
                </div> -->
        </template>
        </el-table-column>

      </el-table>
      <!--  -->
      <div class="pagination-bottom">
        <Pagination
        :total="total"
        :page-size="pageSize"
        :page-count="pageCount"
        @change="handleChange"
      />
      </div>
      <!-- 列表 -->

    </div>
  </div>

</template>

<script>
import { productList } from '@/service/requestRes';
/* eslint-disable */
export default {
  components: {
  },
  data() {
    return {
      isFilter: false,
      searchName: '',
      createDate: '',
      tableData: [],
      total: 0,
      pageSize: 10,
      pageCount: 1,
    };
  },
  computed: {
    headerLables() {
      return [
        { label: this.$t('product.ProductName'), value: 'name' },
        { label: this.$t('product.addedDomain'), value: 'hosts_limit' },
        { label: this.$t('product.setMeal'), value: 'attribute_asset' },
        { label: this.$t('product.createDate'), value: 'created_at' },
        { label: this.$t('product.handle'), value: 'handle' },
      ];
    },
    tabs() {
      return [this.$t('product.myProduct')];
    },
  },
  mounted() {
    this.getProductList({ page: 1 });
  },
  watch: {
    '$i18n.locale': function (e) {
      this.getProductList({ page: 1 });
    },
  },
  methods: {
    getProductList({
      page, start_date, end_date, name,
    }) {
      productList(
        {
          page,
          limit: this.pageSize,
          start_date,
          end_date,
          name,
        },
      ).then((res) => {
        const { data, code, msg } = res || {};
        if (code === 1) {
          const { list } = data || {};
          const { total } = list || {};
          this.total = total;
        const ab = {'基础版': 'Basic Edition', '企业版': 'Enterprise Edition', '直播版': ' Live Stream'};
      const { locale } = this.$i18n;
        const flag = (locale === 'en_US');
          this.tableData = list.data && list.data.map(item => {
            return {
              ...item,
              attribute_asset: {
                ...item.attribute_asset,
                name: flag ? ab[item.attribute_asset.name] : item.attribute_asset.name
              }
            }
          });
        } else {
          this.$message({
            message: msg,
            type: 'error',
          });
        }
      });
    },
    handleChange(e) {
      this.getProductList({ page: e });
    },
    refresh() {
      this.getProductList({ page: 1 });
    },
    filterClick() {
      this.isFilter = !this.isFilter;
    },
    searchClick() {
      let start = '';
      let end = '';
      if (this.createDate && this.createDate.length == 2) {
        start = this.createDate[0];
        end = this.createDate[1];
      }
      window.console.debug(this.createDate);
      this.getProductList({
        page: 1, start_date: start, end_date: end, name: this.searchName,
      });
    },
    resetClick() {
      this.searchName = '';
      this.createDate = '';
      this.$refs.createdate.changeDate('');
    },
  },
};
</script>
<style lang="scss" scoped>
.users-out {
  width: 1276px;
  margin: 24px auto;
}
  .users-manage {
    background-color: white;
    padding: 0 24px 24px 24px;
    border-radius: 4px;
    .menu-title {
      width: 100%;
      display: flex;
      justify-content: space-between;
      span {
        font-family: PingFangSC-Semibold;
        font-size: 14px;
        color: #5A607F;
      }
      .menu-right {
        height: 60px;
        display: flex;
        align-items: center;
      }
    }
    .filter-container {
      display: flex;
      align-items: center;
    }
    .input-container {
      display: flex;
      align-items: center;
      margin-bottom: 24px;
    }
    .search-btn-content {
      display: flex;
      margin-bottom: 49px;
    }
    .user-handle {
      display: flex;
      align-items: center;
      :first-child {
        margin-right: 10px;
        width: 16px;
        height: 16px;
      }
      :last-child {
        width: 18px;
        height: 19px;
      }
    }
  }

    .handle-first {
      display: flex;
      align-items: center;
      :nth-child(1) {
        margin-right: 10px;
        font-family: PingFangSC-Semibold;
        font-size: 12px;
        color: #003600;
        cursor: pointer;
      }
      :nth-child(2) {
        font-family: PingFangSC-Semibold;
        font-size: 12px;
        color: #003600;
        margin-right: 10px;
        cursor: pointer;
      }

      :nth-child(3) {
        font-family: PingFangSC-Semibold;
        font-size: 12px;
        color: #003600;
        cursor: pointer;
      }
    }
</style>
